define('rest/geocode',['http', './utils', 'security', 'endpoints'],
    function(http, utils, security, endpoints) {
        'use strict';

        var queryParamNames = [
            'storeResult', 'typeahead', 'limit', 'ofs', 'lat', 'lon', 'countrySet', 'radius', 'topLeft', 'btmRight', 'language'
        ];

        return {
            geocode: function(options, callback) {
                var pathParams = {}, queryParams = {};

                pathParams.query = utils.required(options.query, '"query" parameter is required for geocode service.');
                queryParams.key = utils.or(options.key, security.getKey('services/search'));

                utils.extractQueryParams(options, queryParams, queryParamNames);
                http.get({
                    url: '{protocol}://' + endpoints.geocode,
                    pathParameters: pathParams,
                    queryParameters: queryParams,
                    callback: callback,
                    callbackParam: 'callback',
                    fail: options.fail
                });
            }
        };
    }
);

